export const AuraMark = ({ className = "w-8 h-8" }) => (
  <img src="/img/aura-a.png" alt="" aria-hidden="true" draggable={false} className={`object-contain select-none ${className}`} />
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display font-extrabold tracking-tight ${className}`}>
    AURA<span className="text-[#f43f5e]">_</span>
  </span>
);
